import { render, staticRenderFns } from "./NeedHelp.vue?vue&type=template&id=6370da39&scoped=true&"
import script from "./NeedHelp.vue?vue&type=script&lang=ts&"
export * from "./NeedHelp.vue?vue&type=script&lang=ts&"
import style0 from "./NeedHelp.vue?vue&type=style&index=0&id=6370da39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370da39",
  null
  
)

export default component.exports